<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>留学跟进</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList();"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList();">查询</el-button>
        </el-form-item>
      </el-form>
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>跟进通知记录列表</span>
        </div>
        <!-- 列表定义 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%;"
        >
          <el-table-column prop="userName" label="姓名"></el-table-column>
          <el-table-column prop="subject" label="通知内容"></el-table-column>
          <el-table-column prop="createTime" label="通知时间"></el-table-column>
          <el-table-column label="是否已读">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.isRead">是</el-tag>
              <el-tag type="danger" v-else>否</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="readTime" label="标记时间"></el-table-column>

          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="查看" placement="top">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-link"
                    @click="viewClick(scope.row)"
                  ></el-button>
                </el-tooltip>

                <el-tooltip content="标记已读" placement="top" v-if="scope.row.isRead==false">
                  <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-view"
                    @click="setView(scope.row.id,true)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50,100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      domain: url.getDomain(),
      query: {}, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      submiting: false
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      //刷新列表
      this.getList();
    },

    getList: function() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      params.type = 1;
      var link = url.getNotice("getlist");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },

    //搜索查询
    selList: function() {
      this.currentPage4 = 1;
      this.getList();
    },
    //查看链接
    viewClick: function(row) {
      var link = row.linkUrl;
      if (link) {
        link = JSON.parse(link);
        this.$router.push(link);
      }
      if (row.isRead == false) {
        this.setView(row.id, false);
      }
    },
    //标记已读
    setView: function(id, isReload) {
      var _this = this;
      var link = url.getNotice("setread");
      $.post(link, { id: id }, res => {
        if (res.status) {
          if (isReload) {
            _this.$message({
              type: "success",
              message: res.msg
            });
            _this.getList();
          }
        } else {
          _this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    }
  },
  created() {},
  mounted() {
    //获取服务器列表
    this.getList();
  }
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.el-form-item--small.el-form-item {
  margin-right: 0px;
}
.el-button--primary {
  margin-left: 10px;
}
</style>
